import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router";
import { connect } from "react-redux";
import QuestionsTab from "./QuestionsTab";
import CurrentTab from "./CurrentTab";
import TrendsTab from "./TrendsTab";
import { Badge } from "reactstrap";

function DEIMaturityModel(props) {
  const [tab, setTab] = useState(1);
  const [persistedState, setPersistedState] = useState({
    questions: [],
    selectedDate: null,
  });

  const isExternal = window.location.pathname.indexOf("/maturity-model/external") >= 0

  const changeTab = (n) => {
    setTab(n);
    if (n === 1) {
      props.history.push("questions");
    } else if (n === 2) {
      props.history.push("current");
    } else if (n === 3) {
      props.history.push("trends");
    }
  };

  useEffect(() => {
    const url = props.location.pathname;

    // alert(url)

    if (url.indexOf("trends") > 0) {
      setTab(3);
    }
    if (url.indexOf("current") > 0) {
      setTab(2);
    }

    if (url.indexOf("questions") > 0) {
      setTab(1);
    }

   
  }, []);
  return (
    <div className={isExternal ? "mm_page_container_external":"mm_page_container"}>
      {console.log("props.match.url", props.match.url)}
      <div className="my-0">
        <div className="profile-user-page">
          <ul className="data-user" style={{ width: "100%" }}>
            <li>
              <a
                className={`${
                  tab == 1 ? "profile_page_menu_option_active" : ""
                }`}
                onClick={() => changeTab(1)}
              >
                Questions
              </a>
            </li>
            <li>
              <a
                className={`${
                  tab == 2 ? "profile_page_menu_option_active" : ""
                }`}
                onClick={() => changeTab(2)}
              >
                Snapshot
              </a>
            </li>
            <li className={isExternal && "external-trends-disabled"}>
              <a
                className={`${
                  tab == 3 ? "profile_page_menu_option_active" : ""
                }`}
                onClick={() => !isExternal ? changeTab(3): null}
              >
                Trends  {isExternal && <Badge className="ml-4 text-white" pill color="danger">Upgrade</Badge> } 
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={props.match.url + "/questions"}
          render={(props) => {
            return (
              <QuestionsTab
                {...props}
                persistedState={persistedState}
                setPersistedState={setPersistedState}
              />
            );
          }}
        />
        <Route
          exact
          path={props.match.url + "/current"}
          component={CurrentTab}
        />
        {
          !isExternal && <Route exact path={props.match.url + "/trends"} component={TrendsTab} />
        }
        
        <Redirect from="*" to={props.match.url + "/questions"} />
      </Switch>
    </div>
  );
}

const mapStateToProps = () => {};
const mapDispatchToProps = () => {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DEIMaturityModel)
);
